var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drag-item",class:{ 'draggable': _vm.draggable }},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"text"},[_vm._t("default")],2)]),_c('span',{staticClass:"fas dragging-icon el-icon-fa-plus-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }